export type FieldErrors = Record<string, string>;

/** Validation errors arrive per field as either a message or a list of them. */
export function firstErrorPerField(errors: Record<string, string | string[]>): FieldErrors {
  return Object.fromEntries(
    Object.entries(errors).map(([field, message]) => [
      field,
      Array.isArray(message) ? message[0] : message
    ])
  );
}
